import { Button } from 'antd';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DsRequestProvider } from './context';
import Header from './Header';
import IconEmpty from '../../assets/Images/icons/emptyCustom';
import DSRequestFormService from '../../services/DSRequestForm.service';
import UserService from '../../services/UserService';
import { ROUTER } from '../../constants/router';
import DataFlowService from '../../services/DataFlow.service';
import GlobalService from '../../services/Global.service';
import PreviewForm from './PreviewForm';

const DsRequestForm = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [domainSelection, setDomainSelection] = useState();
    const [initialValue, setInitialValue] = useState();
    const [countDataFlow, setCountDataFlow] = useState();

    useEffect(() => {
        const checkDataFlow = async () => {
            const STATUS_ID = [
                '1e1fa784f2a911ec8bf4fa163e89e3c8', // ร่าง
                '2940de90f2a911ec8bf4fa163e89e3c8', //รอตรวจสอบ
                '14094f73f2a911ec8bf4fa163e89e3c8', //ตรวจสอบแล้ว
                '23c31c18f2a911ec8bf4fa163e89e3c8', //ส่งคืนแก้ไข
            ];
            try {
                const { data } = await DataFlowService.searchDataFlowList({
                    departmentId: '',
                    businessProcessName: '',
                    purposeName: '',
                    reviewBy: '',
                    status: STATUS_ID.join(','),
                    startDate: '',
                    endDate: '',
                    p: 1,
                    ps: 10,
                    s: 'modify_date',
                    sd: 'DESC',
                });
                setCountDataFlow(data?.resultData?.result?.length);
            } catch (err) {
                console.log(err);
            }
        };
        checkDataFlow();
    }, []);

    const [requestType, setRequestType] = useState([]);

    useEffect(() => {
        const fetchRequestType = async () => {
            try {
                const response = await GlobalService.getRequestType();
                const resultData = response.data?.resultData;
                let requestType = [];
                if (resultData && resultData.length > 0) {
                    requestType = resultData;
                    requestType.sort((a, b) => a?.sequence - b?.sequence);
                }
                setRequestType(requestType);
            } catch (error) {
                console.log(error);
            }
        };
        fetchRequestType();
    }, []);

    const getCustomize = async (domainSelection) => {
        try {
            const { data } = await DSRequestFormService.getCustomize(
                domainSelection
            );
            if (data?.resultCode === 1) {
                const resultData = data?.resultData;
                const dataSubjectType =
                    resultData?.customizeForm?.dataSubjectType
                        .filter((ds) => ds.isUsed)
                        .map((ds) => ds.id);

                const dataSubjectTypeAddOn =
                    resultData?.customizeForm?.dataSubjectTypeAddOn?.map(
                        (ds) => {
                            return {
                                ...ds,
                                dataSubjectAddOnName: ds.name,
                            };
                        }
                    );

                // Sort rightDescriptionList with requestType sequence
                const rightDescriptionList =
                    resultData?.rightDescriptionList?.sort((a, b) => {
                        const aSequence = requestType.find(
                            (item) =>
                                item.requestTypeId === a.mdataSubjectRightId
                        )?.sequence;
                        const bSequence = requestType.find(
                            (item) =>
                                item.requestTypeId === b.mdataSubjectRightId
                        )?.sequence;
                        return aSequence - bSequence;
                    });

                const initial = {
                    domainId: resultData?.domainId,
                    updateDate: resultData?.updateDate,
                    updateByFullname: resultData?.updateByFullname,
                    customizeForm: {
                        ...resultData?.customizeForm,
                        dataSubjectType,
                        dataSubjectTypeAddOn,
                    },
                    // customizeStyle: resultData?.customizeStyle,
                    customizeStyle: {
                        mainColor: resultData?.customizeStyle?.mainColor,
                        bgColor: resultData?.customizeStyle?.bgColor,
                        buttonColor: resultData?.customizeStyle?.buttonColor,
                    },
                    fontStyle: {
                        ...resultData?.fontStyle,
                        fontSize:
                            resultData?.fontStyle?.fontSize === 'small'
                                ? '14px'
                                : '16px',
                        fontFamily:
                            resultData?.fontStyle?.fontFamily.toLowerCase(),
                    },
                    logo: resultData?.logo,
                    isUsedInventory: resultData?.isUsedInventory,
                    thankyou: {
                        topic: resultData?.thankyou?.topic,
                        detail: resultData?.thankyou?.detail,
                    },
                    rightDescriptionList,
                };
                await setInitialValue(initial);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (domainSelection && requestType) {
            getCustomize(domainSelection);
        }
    }, [domainSelection, requestType]);

    const permission = UserService.permissions();
    const isAllow = permission?.find((element) => element === 'INVENTORY');

    return (
        <DsRequestProvider>
            <div className="title flex">{t('DS Request Form')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('DataSubject360')} /
                </span>
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('DS Request Form')}
                </span>
            </div>
            {isAllow !== 'INVENTORY' ? (
                <>
                    <Header
                        domainSelection={domainSelection}
                        setDomainSelection={setDomainSelection}
                        values={initialValue}
                    />
                    {domainSelection ? (
                        <PreviewForm
                            requestType={requestType}
                            getCustomize={() => getCustomize(domainSelection)}
                            domainSelection={domainSelection}
                            setDomainSelection={setDomainSelection}
                            initialValue={initialValue}
                        />
                    ) : (
                        <div>
                            <div className="mt-32">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <>
                    {countDataFlow > 0 ? (
                        <>
                            <Header
                                domainSelection={domainSelection}
                                setDomainSelection={setDomainSelection}
                                values={initialValue}
                            />
                            {domainSelection ? (
                                <PreviewForm
                                    requestType={requestType}
                                    getCustomize={() =>
                                        getCustomize(domainSelection)
                                    }
                                    domainSelection={domainSelection}
                                    setDomainSelection={setDomainSelection}
                                    initialValue={initialValue}
                                />
                            ) : (
                                <div>
                                    <div className="mt-32">
                                        <IconEmpty />
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="space-y-5 mt-44">
                            <IconEmpty
                                text={`<span style="color:#65707A;">กรุณาสร้าง Data Flow ก่อนจึงสามารถสร้าง DS Request Form ได้</span>`}
                            />
                            <div className="text-center">
                                <Button
                                    onClick={() => {
                                        navigate(ROUTER.DS_INVENTORY.DATAFLOW);
                                    }}
                                    type="primary"
                                    size="large"
                                >
                                    ไปยังหน้า Data Flow
                                </Button>
                            </div>
                        </div>
                    )}
                </>
            )}
        </DsRequestProvider>
    );
};

export { DsRequestForm };
